{
	"about": {
		"title": "Om appen",
		"version": "Versjon",
		"build-number": "Byggenummer",
		"new-version": "Ny versjon"
	},
	"legal": {
		"privacy-policy": "Personvernregler",
		"terms-of-use": "Vilkår for bruk"
	}
}
